import { DataService } from './../services/data.service';
import { ShopDetailsPage } from './../shop-details/shop-details.page';
import { EventService } from './../services/event.service';
import { ArtikelResponse } from './../classes/artikel';
import { ArtikelService } from './../services/artikel.service';
import { Artikel } from '../classes/artikel';
import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { NavParams, ModalController, Platform, IonInput } from '@ionic/angular';
import { getConfig } from '../classes/getConfig/getConfig';

@Component({
  selector: 'app-shop-sorten',
  templateUrl: './shop-sorten.page.html',
  styleUrls: ['./shop-sorten.page.scss'],
})
export class ShopSortenPage {
  @ViewChild('inputHinweis', { read: IonInput }) inputHinweis: IonInput;
  @ViewChild('inputEh', { read: IonInput }) inputEh: IonInput;

  public mainItem: Artikel = null;
  public eh = 0;
  public hinweis = '';
  // public small = getConfig().zeigeSortenInDetailfenster;
  public config = getConfig();
  private isInfo = false;
  public lieferdatum: string = null;
  public artikelRes: ArtikelResponse = null;
  public shop: string;
  public kondition: string;

  constructor(public navParams: NavParams, public data: DataService, public modalCtrl: ModalController, public platform: Platform,
              public artikelService: ArtikelService, private eventService: EventService, public modalController: ModalController) {
    this.artikelRes = navParams.data.artikelRes;
    this.mainItem = navParams.data.item;
    this.isInfo = navParams.data.isInfo;
    this.lieferdatum = navParams.data.lieferdatum;
    this.shop = navParams.data.shop;
    this.kondition = navParams.data.kondition;
    this.eh = this.mainItem.pos.eh;
    this.hinweis = this.mainItem.pos.hinweis;

  }

  public isInfoView(): boolean {
    return this.isInfo || !this.artikelRes.bestellungErlaubt;
  }

  topfAusblenden(): boolean {
    return this.config.topfAusblenden;
  }

  public calcWarenwert() {}

  public nochNichtLieferbar(item: Artikel): boolean {
    return this.artikelService.nochNichtLieferbar(item, this.lieferdatum);
  }

  public nichtMehrLieferbar(item: Artikel): boolean {
    return this.artikelService.nichtMehrLieferbar(item, this.lieferdatum);
  }

  public lieferbar(item: Artikel): boolean {
    return this.artikelService.lieferbar(item, this.lieferdatum, this.artikelRes.nochNichtLieferbareAnzeigen);
  }

  hover(item: Artikel) {
    if (item.bildUrl.indexOf('View.aspx') === -1) {
      this.eventService.imageUrlChanged$.emit(item.bildUrl);
    }
  }

  async edit(item: Artikel) {
    this.modalController.create({
      component: ShopDetailsPage,
      componentProps: { item: item, isInfo: this.isInfoView() }
    })
    .then((value) => {
      value.onDidDismiss().then((val) => {
        this.updateWarenkorb(item);
      });
      value.present();
    });
  }

  schliessen() {
    this.modalCtrl.dismiss(null);
  }

  updateWarenkorb(item: Artikel) {
    this.data.setWarenkorb(this.shop, this.kondition, item);
  }
}
